import React from "react"

import ApplicationStepper from "@/components/application/ApplicationStepper"
import TrialConfirmation from "@/components/application/TrialConfirmation"
import AppLayout from "@/components/layout/AppLayout"

const TrialPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4">
        <ApplicationStepper />
        <h1 className="mb-2 text-center text-2xl font-bold text-jungle md:text-2xl">
          Trial Blocks
        </h1>
        <p className="mb-8 text-center text-gray-600">
          You're ready to start your trial block with HIVED
        </p>
        <TrialConfirmation />
      </div>
    </AppLayout>
  )
}

export default TrialPage
